import BaseApi from '../base';

class TestApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getCategories(token) {
    return this.makeRequest(this.METHOD_GET, 'categories', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getTests(token) {
    return this.makeRequest(this.METHOD_GET, 'tests', token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateTest(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `tests/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async deleteTest(token, id) {
    return this.makeRequest(this.METHOD_POST, `tests/${id}/delete`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async createTest(token, data) {
    return this.makeRequest(this.METHOD_POST, 'tests', token, data);
  }

  /**
   * @param {string} token
   * @param {string} clientId
   * @returns {Promise<*>}
   */
  async getResults(token, clientId) {
    return this.makeRequest(this.METHOD_GET, `results?client=${clientId}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addResult(token, data) {
    return this.makeRequest(this.METHOD_POST, 'results', token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @param data
   * @returns {Promise<*>}
   */
  async updateResult(token, id, data) {
    return this.makeRequest(this.METHOD_POST, `results/${id}`, token, data);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async deleteResult(token, id) {
    return this.makeRequest(this.METHOD_POST, `results/${id}/delete`, token);
  }
}

export default TestApi;
